import { useState, useCallback } from 'react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from './ui/alert-dialog';

export const useConfirm = () => {
    const [state, setState] = useState(null);
    const confirm = useCallback((message, opts = {}) => new Promise(resolve => setState({ message, ...opts, resolve })), []);
    const close = (ok) => { state?.resolve(ok); setState(null); };
    const dialog = (
        <AlertDialog open={!!state} onOpenChange={(o) => { if (!o) close(false); }}>
            <AlertDialogContent data-testid="confirm-dialog" className="bg-white border-gray-200">
                <AlertDialogHeader>
                    <AlertDialogTitle>{state?.title || 'Confirmation'}</AlertDialogTitle>
                    <AlertDialogDescription className="whitespace-pre-line">{state?.message}</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel data-testid="confirm-dialog-cancel">Annuler</AlertDialogCancel>
                    <AlertDialogAction onClick={() => close(true)} data-testid="confirm-dialog-ok"
                        className={state?.danger ? 'bg-red-600 hover:bg-red-700' : ''}>{state?.confirmLabel || 'Confirmer'}</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
    return [confirm, dialog];
};
